import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "head flex flex-ai-c" }
const _hoisted_3 = { class: "fs-16 bold" }
const _hoisted_4 = { class: "fs-16 bold fc-orange" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "body mg-t-20" }
const _hoisted_7 = { class: "flex mg-b-12" }
const _hoisted_8 = { class: "w-200" }
const _hoisted_9 = { class: "bold" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "w-300" }
const _hoisted_12 = { class: "bold" }
const _hoisted_13 = { class: "flex-1" }
const _hoisted_14 = { class: "bold" }
const _hoisted_15 = { class: "flex mg-b-12" }
const _hoisted_16 = { class: "w-200" }
const _hoisted_17 = { class: "bold" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { class: "w-300" }
const _hoisted_20 = { class: "bold" }
const _hoisted_21 = { class: "flex-1" }
const _hoisted_22 = { class: "bold" }
const _hoisted_23 = { class: "flex" }
const _hoisted_24 = { class: "w-200" }
const _hoisted_25 = { class: "bold" }
const _hoisted_26 = { class: "w-300" }
const _hoisted_27 = {
  key: 0,
  class: "bold"
}
const _hoisted_28 = {
  key: 1,
  class: "bold"
}
const _hoisted_29 = { class: "flex-1" }
const _hoisted_30 = { class: "bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_card, { shadow: "never" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.setDefault(_ctx.detail.serveCompanyName)), 1),
          _cache[0] || (_cache[0] = _createElementVNode("div", { class: "fs-12 fc-lightgray mg-l-16" }, "实发金额：", -1)),
          _createElementVNode("div", _hoisted_4, [
            (_ctx.detail.payRealHairTotalMoney || _ctx.detail.payRealHairTotalMoney === 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, "¥"))
              : _createCommentVNode("", true),
            _createTextVNode(_toDisplayString(_ctx.setDefault(_ctx.detail.payRealHairTotalMoney)), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _cache[1] || (_cache[1] = _createElementVNode("span", { class: "fc-lightgray" }, "待领金额：", -1)),
              _createElementVNode("span", _hoisted_9, [
                (_ctx.detail.totalWaitPay || _ctx.detail.totalWaitPay === 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_10, "¥"))
                  : _createCommentVNode("", true),
                _createTextVNode(_toDisplayString(_ctx.setDefault(_ctx.detail.totalWaitPay)), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _cache[2] || (_cache[2] = _createElementVNode("span", { class: "fc-lightgray" }, "申请时间：", -1)),
              _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.setDefault(_ctx.detail.createTime)), 1)
            ]),
            _createElementVNode("div", _hoisted_13, [
              _cache[3] || (_cache[3] = _createElementVNode("span", { class: "fc-lightgray" }, "所属企业：", -1)),
              _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.setDefault(_ctx.detail.serveCompanyName)), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _cache[4] || (_cache[4] = _createElementVNode("span", { class: "fc-lightgray" }, "停发金额：", -1)),
              _createElementVNode("span", _hoisted_17, [
                (_ctx.detail.payStopTotalMoney || _ctx.detail.payStopTotalMoney === 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_18, "¥"))
                  : _createCommentVNode("", true),
                _createTextVNode(_toDisplayString(_ctx.setDefault(_ctx.detail.payStopTotalMoney)), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _cache[5] || (_cache[5] = _createElementVNode("span", { class: "fc-lightgray" }, "发薪时间：", -1)),
              _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.setDefault(_ctx.detail.approvalTime)), 1)
            ]),
            _createElementVNode("div", _hoisted_21, [
              _cache[6] || (_cache[6] = _createElementVNode("span", { class: "fc-lightgray" }, "申请人：", -1)),
              _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.setDefault(_ctx.detail.createUserName)), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _cache[7] || (_cache[7] = _createElementVNode("span", { class: "fc-lightgray" }, "发薪人数：", -1)),
              _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.setDefault(_ctx.detail.peopleNum)), 1)
            ]),
            _createElementVNode("div", _hoisted_26, [
              _cache[8] || (_cache[8] = _createElementVNode("span", { class: "fc-lightgray" }, "支付方式：", -1)),
              (_ctx.setDefault(_ctx.detail.payAccountFlag) === 10001)
                ? (_openBlock(), _createElementBlock("span", _hoisted_27, "微信支付"))
                : _createCommentVNode("", true),
              (_ctx.setDefault(_ctx.detail.payAccountFlag) === 20001)
                ? (_openBlock(), _createElementBlock("span", _hoisted_28, "支付宝支付"))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_29, [
              _cache[9] || (_cache[9] = _createElementVNode("span", { class: "fc-lightgray" }, "发薪备注：", -1)),
              _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.setDefault(_ctx.detail.remarks)), 1)
            ])
          ])
        ])
      ]),
      _: 1
    })
  ]))
}